export function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade encryption and advanced security protocols protect your data and privacy on iOS devices'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Performance Optimization',
      description: 'Smart algorithms optimize device performance by cleaning junk files and managing system resources efficiently'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'User-Friendly Design',
      description: 'Intuitive interfaces designed following iOS guidelines ensure seamless user experience and easy navigation'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Coverage',
      description: 'Access to worldwide server network providing fast and reliable connections from anywhere in the world'
    },
    {
      icon: 'ri-lock-password-line',
      title: 'Privacy Protection',
      description: 'Strict no-logs policy and advanced privacy features ensure your online activities remain completely private'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Dedicated support team available around the clock to assist with any questions or technical issues'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Features
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive features designed to provide the best mobile security and performance optimization experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
